import React, { useEffect } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { GetStaticProps } from 'next';
import { getFrontpage, getNewAndUpdatedSingle, getLearningPathsOverview, getLandingPage } from 'data/contentful-api';
import Layout from 'layouts/landing-page-new-design';
import { frontpageIds } from 'utils/constants';
import LandingHero from '../components/tailwind-m/landing-hero';
// import LandingOverview from '../components/tailwind-m/landing-overview';
import { useUserData } from 'utils/user';
import { useIsAuthenticated } from '@azure/msal-react';
import bookmarksApi from '../apiFrontend/bookmarksApi';
import { useDispatch } from 'react-redux';
import i18n, { SettingsType } from 'utils/i18n';
import { useRouter } from 'next/router';

import Hero from '../components-aria/hero';
import TestimonialSection from '../components-aria/testimonial-section';
import FeatureSection from '../components-aria/feature-section';
import SolutionsSection from '../components-aria/solutions-section';
import ProfileSection from '../components-aria/profile-section';
import SignInSection from '../components-aria/sign-in-section';

interface FrontpageProps {
  frontpage: Frontpage;
  newUpdatedRecently: any;
  landingPage: any;
}

export const Home: React.FC<FrontpageProps> = ({ frontpage, newUpdatedRecently, landingPage }) => {
  const { locale, push } = useRouter();
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();
  const { accounts, accessToken } = useUserData();
  const account = accounts[0];
  const { quickLinks } = i18n[(locale as AcceptedLocales) || 'en-US'] as SettingsType;

  const { data: bookmarksData, refetch: bookmarksRefetch } = bookmarksApi.useGetBookmarksQuery(null, {
    skip: !isAuthenticated || !accessToken,
  });

  useEffect(() => {
    if (isAuthenticated && accessToken) {
      bookmarksRefetch();
    }

    return () => {
      dispatch(bookmarksApi.util.invalidateTags(['all-bookmarks']));
    };
  }, [isAuthenticated, accessToken, bookmarksRefetch, accounts, dispatch]);

  const name =
    `${(account?.idTokenClaims as Record<string, unknown>)?.given_name || ''} ${
      (account?.idTokenClaims as Record<string, unknown>)?.family_name || ''
    }`.trim() ||
    account?.name ||
    ((account?.idTokenClaims as Record<string, unknown>)?.name as string) ||
    ((account?.idTokenClaims as Record<string, unknown>)?.display_name as string) ||
    (account?.username as string);

  console.log('landingPage', landingPage);

  return (
    <Layout title={frontpage.meta.title} description={frontpage.meta.description} mainClassName="new-design">
      <Hero title={landingPage.title} text={landingPage.heroText} />
      <AuthenticatedTemplate>
        <ProfileSection bookmarks={bookmarksData} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <SignInSection />
      </UnauthenticatedTemplate>
      <SolutionsSection
        title={landingPage.solutionsSectionTitle}
        description={landingPage.solutionsSectionText}
        solutions={landingPage.solutionsListCollection}
      />
      <FeatureSection
        bgColor="#F5EDDA"
        imageUrl="/images/ideas.png"
        imageAlt="Feature image"
        title="Share your ideas!"
        // description="Submit your ideas for new features, suggest improvements to the existing ones, or view, vote or comment on other people's ideas."
        links={quickLinks}
      />
      <TestimonialSection
        bgColor="#FFFDF8"
        imageUrl="/images/testimonial.png"
        quoteText="One thing I’m still impressed about: we have 45 companies, and everything is sent to one email address. The system figures out where it needs to go. So, it’s quite impressive."
        author="Monique Jacquem, CFO of Basecamp"
        imageAlt="Monique Jacquem"
      />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps<any> = async ({ locale }) => {
  const frontpage = await getFrontpage({ locale: 'en-US', frontpageId: frontpageIds.frontpage });
  const newUpdatedRecently = await getNewAndUpdatedSingle({ locale: 'en-US' });
  const landingPage = await getLandingPage({ locale: 'en-US' });

  console.log('landingPage', landingPage);

  if (!frontpage) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      frontpage,
      newUpdatedRecently,
      landingPage,
    },
    revalidate: 1,
  };
};

export default Home;
